import { render, staticRenderFns } from "./GameTrailer.vue?vue&type=template&id=01f176f2&scoped=true"
import script from "./GameTrailer.vue?vue&type=script&lang=js"
export * from "./GameTrailer.vue?vue&type=script&lang=js"
import style0 from "./GameTrailer.vue?vue&type=style&index=0&id=01f176f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f176f2",
  null
  
)

export default component.exports